import React from 'react';
import ReactDOM from 'react-dom/client';

// Bootstrap CSS & JS should be imported before custom styles
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';

// Custom styles
import './index.scss';

import App from './App';
import reportWebVitals from './reportWebVitals';

// Initialize the root element
const rootElement = document.getElementById('root');

if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

// Performance monitoring
reportWebVitals();
